import React from 'react';
import { StyleSheet, View } from 'react-native';
import useColors from 'hooks/useColors';
import { formatAmount, formatDateForItem } from 'utils';
import BlurAmountView from './BlurAmountView';
import { ProgressBar } from './ProgressBar';
import Spacer from './Spacer';
import Text from './Text';
/**
 * A view with three rows: progress in text, a progress bar, remaining amount and end date.
 */
const SavingsProgress = ({ currency, balance: balanceUnprocessed, goalAmount: goalAmountUnprocessed, percentage: percentageUnprocessed, endDate, progressBarColor, progressBarBackgroundColor, progressBarAnimationDisabled, scrambled, }) => {
    const colors = useColors();
    const goalAmount = Math.max(0, goalAmountUnprocessed);
    const balance = Math.max(0, balanceUnprocessed);
    const percentage = percentageUnprocessed ??
        (goalAmount > 0 ? Math.min(1, balance / goalAmount) * 100 : 100);
    let progressBarColors;
    if (Array.isArray(progressBarColor)) {
        progressBarColors = progressBarColor;
    }
    else if (progressBarColor) {
        progressBarColors = [progressBarColor, progressBarColor];
    }
    else {
        progressBarColors = colors.gradients.ultimate.colors;
    }
    const amountLeft = goalAmount - balance;
    return (<>
      <View style={styles.row}>
        <BlurAmountView enabled={scrambled}>
          <Text Numbers-16>{percentage.toFixed(1)}%</Text>
        </BlurAmountView>
        <BlurAmountView enabled={scrambled}>
          <Text Numbers-16>{`${formatAmount(balance, currency, 2)} / ${formatAmount(goalAmount, currency, 2)}`}</Text>
        </BlurAmountView>
      </View>
      <Spacer.H8 />
      <ProgressBar animateInitial={!progressBarAnimationDisabled} position={percentage} colors={progressBarColors} barBackgroundColor={progressBarBackgroundColor}/>
      <Spacer.H8 />
      {endDate ? (<View style={styles.row}>
          <BlurAmountView enabled={scrambled}>
            <Text TextThin-14 Secondary>
              {formatAmount(Math.abs(amountLeft), currency, 2)}{' '}
              {amountLeft >= 0 ? 'left' : 'over'}
            </Text>
          </BlurAmountView>
          <Text TextThin-14 Secondary>
            by {formatDateForItem(endDate)}
          </Text>
        </View>) : null}
    </>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});
export default React.memo(SavingsProgress);
